import { render, staticRenderFns } from "./Prospects.vue?vue&type=template&id=550d3120&"
import script from "./Prospects.vue?vue&type=script&lang=js&"
export * from "./Prospects.vue?vue&type=script&lang=js&"
import style0 from "./Prospects.vue?vue&type=style&index=0&id=550d3120&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports